// Implements: F-UIX-019
/**
 * The notices at the top of the platform view (UIX.8): the red "Límites desactivados" and
 * the global spend alert. They read the status panel's own query (one request for both);
 * while it loads or when it fails they show nothing, and the panel below says why.
 */

import type { ReactElement } from "react";

import { StatusNotices } from "../components/StatusNotices";
import { useSystemStatus } from "../hooks/useSystemStatus";

export function PlatformNoticesContainer(): ReactElement | null {
  const status = useSystemStatus();
  return status.data === undefined ? null : <StatusNotices view={status.data} />;
}
